export default __webpack_public_path__ + "images/6e651572a82e3950da8096dd4ebb5ae1.svg";